import React from 'react';
import { FilterOptionKeys } from '@mybestbrands/types';
import FilterToggle, { FilterToggleType } from '@/app/ui/components/filters/FilterToggle';
import { useFeatureToggle } from '@/app/featuretoggles/FeatureToggleContext';

const CouponFilter = ({ isActive, type = FilterToggleType.BUTTON }: { isActive: boolean; type?: FilterToggleType }) => {
  const { featureFlags } = useFeatureToggle();

  if (!featureFlags.COUPONS) return null;

  return <FilterToggle isActive={isActive} filterKey={FilterOptionKeys.COUPON} type={type} />;
};

export default CouponFilter;
